import { useState, useCallback } from 'react';

/**
 * Hook personnalisé pour gérer les messages log dans l'application
 * @param {Object} options
 * @param {boolean} options.autoHide - Si true, les messages se masqueront automatiquement
 * @param {number} options.duration - Durée en ms avant que le message ne se masque
 * @returns {Object} - Méthodes et état pour gérer les messages
 */
export function useMessageLog(options = {}) {
  const { autoHide = false, duration = 5000 } = options;
  const [message, setMessageState] = useState({ type: '', text: '', key: null });
  
  // Fonction pour définir un message avec une clé unique
  const setMessage = useCallback((type, text) => {
    // Générer une clé unique pour chaque message pour permettre l'affichage répété
    const uniqueKey = `${type}-${Date.now()}-${Math.random()}`;
    setMessageState({ type, text, key: uniqueKey });
  }, []);
  
  // Fonctions spécifiques pour chaque type de message
  const showError = useCallback((text) => {
    const uniqueKey = `error-${Date.now()}-${Math.random()}`;
    setMessageState({ type: 'error', text, key: uniqueKey });
  }, []);
  
  const showSuccess = useCallback((text) => {
    const uniqueKey = `success-${Date.now()}-${Math.random()}`;
    setMessageState({ type: 'success', text, key: uniqueKey });
  }, []);
  
  const showInfo = useCallback((text) => {
    const uniqueKey = `info-${Date.now()}-${Math.random()}`;
    setMessageState({ type: 'info', text, key: uniqueKey });
  }, []);
  
  const showWarning = useCallback((text) => {
    const uniqueKey = `warning-${Date.now()}-${Math.random()}`;
    setMessageState({ type: 'warning', text, key: uniqueKey });
  }, []);
  
  // Fonction pour effacer le message
  const clearMessage = useCallback(() => {
    setMessageState({ type: '', text: '', key: null });
  }, []);
  
  return {
    message,
    setMessage,
    showError,
    showSuccess,
    showInfo,
    showWarning,
    clearMessage,
    messageConfig: {
      autoHide,
      duration
    }
  };
}
